import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  List,
  ListBody,
  isMobile,
  ListHeader,
  ListHeaderItem,
  useTranslation,
  setTranslationValues,
  statisticsStore,
} from '@pascal/pascal-core';

import { StatisticsItemsWrapper } from '../../../components/common';
import { globalTranslationKeys, lastRoundValue } from '../../../enums';

export const StatisticsWr = observer(() => {
  const t = useTranslation();
  const [statistics, setStatistics] = useState({});

  useEffect(() => {
    const fetchStatistics = async () => {
      const result = await statisticsStore.getHttpStatistics({ isReturnStatistics: true });

      if (result) {
        const sortedEntries = Object.entries(result).sort(([, a], [, b]) => b - a);
        const sortedRes = Object.fromEntries(sortedEntries);

        setStatistics(sortedRes);
      }
    };

    fetchStatistics();

    return () => setStatistics({});
  }, []);

  return isMobile() ? (
    <StatisticsItemsWrapper t={t} statisticsData={statistics} />
  ) : (
    <List>
      <ListHeader>
        <ListHeaderItem>
          {setTranslationValues(t(globalTranslationKeys.LastValueRounds), lastRoundValue)}
        </ListHeaderItem>
      </ListHeader>
      <ListBody className='scrollable-container statistic-web'>
        <StatisticsItemsWrapper t={t} statisticsData={statistics} />
      </ListBody>
    </List>
  );
});
